import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "typeOptions",
    "paidCheckbox",
    "errorMessage",
    "successMessage"
  ];

  connect() {
    this.hasError = false;
  }

  toggleDrivingSchoolInstructor() {
    // Get the selected instructor ID
    const instructorId = this.typeOptionsTarget.value;

    // Build the URL with the instructor ID parameter
    let url = "/schools/first-lessons";
    if (instructorId && instructorId !== "0") {
      url += `?instructor_id=${instructorId}`;
    }

    // Navigate to the filtered URL
    window.location.href = url;
  }


  markPaidFirstLessons(event) {
    event.preventDefault();

    // hide error message
    this.errorMessageTarget.classList.add("u-hidden");
    // hide success message
    this.successMessageTarget.classList.add("u-hidden");

    // Get all checked lesson IDs
    const checkedLessons = this.paidCheckboxTargets
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    // If no lessons selected, show an error message
    if (checkedLessons.length === 0) {
      this.showMessage("Please select at least one lesson to mark as paid.", "error");
      return;
    }

    // Send AJAX request to update lessons
    fetch('/schools/first-lessons/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        lesson_ids: checkedLessons
      })
    })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok');
        })
        .then(data => {
          // Show success message
          this.showMessage(data.message || "Lessons successfully updated!", "success");
        })
        .catch(error => {
          // Show error message
          this.showMessage("Error updating lessons. Please try again.", "error");
          console.error('Error:', error);
        });
  }

  showMessage(message, type) {
    // Determine which message target to use
    const target = type === "error" ? this.errorMessageTarget : this.successMessageTarget;

    // Set message content
    target.textContent = message;

    // Show the message
    target.classList.remove("u-hidden");
  }
}